import { useEffect } from 'react'

const useHowToSchema = (toolName) => {
    useEffect(() => {
        const stepElements = document.querySelectorAll('.guide-steps .step')
        if (stepElements.length === 0) return

        const steps = Array.from(stepElements).map((el, index) => {
            const title = el.querySelector('.step-content h3')?.textContent?.trim() || `Step ${index + 1}`
            const text = el.querySelector('.step-content p')?.textContent?.trim() || ''
            return {
                "@type": "HowToStep",
                "position": index + 1,
                "name": title,
                "text": text
            }
        })

        const howToSchema = {
            "@context": "https://schema.org",
            "@type": "HowTo",
            "name": `How to Use ${toolName}`,
            "step": steps
        }

        const script = document.createElement('script')
        script.type = 'application/ld+json'
        script.setAttribute('data-schema', 'howto')
        script.textContent = JSON.stringify(howToSchema)
        document.head.appendChild(script)

        return () => {
            document.head.removeChild(script)
        }
    }, [toolName])
}

export default useHowToSchema